var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-box"},[_vm._l((_vm.list),function(section,index){return [_c('NvSection',{key:index,attrs:{"section":section}})]}),_c('img',{staticClass:"banner",attrs:{"src":_vm.bannerImage,"alt":"novelover banner"}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }